import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/logo.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.png";
import navIcon3 from "../assets/img/nav-icon3.png";

export const Footer = () => {
  return (
    <footer className='footer'>
      <Container>
        <Row className='align-items-center'>
          <MailchimpForm />
          <Col size={12} sm={6}>
            <img src={logo} alt='Logo' />
          </Col>
          <Col size={12} sm={6} className='text-center text-sm-end'>
            <div className='social-icon'>
              <a
                href='https://www.linkedin.com/in/rishi-ranjan-6a0394215/'
                target='blank'
              >
                <img src={navIcon1} alt='Icon' />
              </a>
              <a href='https://github.com/rishiranjan16' target='blank'>
                <img src={navIcon2} alt='Icon' />
              </a>
              <a href='https://medium.com/@ranjanrishi82' target='blank'>
                <img src={navIcon3} alt='Icon' />
              </a>
            </div>
            <p>Email: ranjanrishi82@gmail.com</p>
            <p>Phone: +916200063243</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
